import React from 'react';
import {Alert} from "@mui/material";

function UnauthorizedAlert() {
    return (
        <Alert severity='error'>Error: Unauthorized</Alert>
    );
}

export default UnauthorizedAlert;